/**
 * Creates an element with a tooltip icon and the specified tooltip
 * <help-tooltip-icon helpId"1001" />
 */
angular.module('qkr').directive('helpTooltipIcon', ['helpService', function(helpService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            template: '<i class="fa fa-info-circle tooltip-icon"  uib-tooltip="{{helpMsg | translate}}" tooltip-appendToBody="true" tooltip-placement="{{position}}" id="{{helpId}}"></span>',
            link(scope, elem, attrs) {
                if (typeof (attrs.helpid) !== 'undefined') {
                    scope.helpId = attrs.helpid;
                    if (helpService.helpLoaded) {
                        scope.helpMsg = helpService.tooltip(scope.helpId);
                    } else {
                        helpService.loadHelp();
                        scope.$on('HelpLoaded', (as) => {
                            scope.helpMsg = helpService.tooltip(scope.helpId);
                        });
                    }
                }

                if (typeof (attrs.placement) !== 'undefined') {
                    scope.position = attrs.placement;
                } else {
                    scope.position = 'top';
                }
            }
        };
}]);




// WEBPACK FOOTER //
// ./src/directives/help_tooltip_icon.js